import { request } from "../lib/api-client.ts";
import { API_BASE } from "../lib/api-routes.ts";
import type { Schemas } from "../lib/api-schemas.ts";

export type UploadedAttachment = Readonly<Schemas["Attachment"]>;

/** Lo que el backend sabe leer hoy. */
export const ACCEPTED_FILES = ".xlsx,.xls,.csv";

export const MAX_UPLOAD_BYTES = 32 * 1024 * 1024;

/**
 * Sube un archivo a la conversacion.
 *
 * Por `request` como todo lo demas: el cuerpo es multipart y `request` ya sabe
 * no ponerle Content-Type, y asi el token, la base y el sobre de error son los
 * mismos que en el resto del cliente.
 */
export const uploadAttachment = (
  conversationId: string,
  file: File,
): Promise<UploadedAttachment> => {
  const body = new FormData();
  body.append("file", file);

  return request<UploadedAttachment>(
    `${API_BASE}/conversations/${conversationId}/attachments`,
    { method: "POST", body },
  );
};

/** Conversación vacía: hace falta una para colgar el adjunto. */
export const startConversation = async (): Promise<string> => {
  const { conversationId } = await request<Schemas["StartedConversation"]>(
    `${API_BASE}/conversations`,
    { method: "POST" },
  );
  return conversationId;
};
